import {
  lettersNumbersSpacesPattern,
  lettersNumbersDotDashApostropheSpacePattern,
} from 'jl-design-system/form/regex';

// lodash
import isString from 'lodash/isString';

export const excludeSymbolsDeliveryInstructions = (value = '') => {
  if (!isString(value)) {
    return '';
  }
  const regex = new RegExp(`[^${lettersNumbersSpacesPattern}]`, 'g');
  return value.replace(regex, '');
};

export const excludeSymbolsCollectionPointSearch = (value = '') => {
  if (!isString(value)) {
    return '';
  }
  const regex = new RegExp(`[^${lettersNumbersDotDashApostropheSpacePattern}]`, 'g');
  return value.replace(regex, '');
};
